import script from "./CarouselSlide.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselSlide.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselSlide.vue?vue&type=style&index=0&id=7fe8da7f&lang=scss"

const __exports__ = script;

export default __exports__